import styled from 'styled-components';
import React from 'react';
import { useParams } from 'react-router';
import { decryptUtilityAccountPassword } from '/imports/api/utilityAccounts';
import { useMethod } from '/imports/hooks';
import { Page } from '/imports/ui/Page';

const UtilityAccountPasswordPageStyled = styled(Page)`
`;

/** Displays the decrypted password for a utility account. */
export const UtilityAccountPasswordPage = () => {
  const { _id } = useParams<any>();
  const [password,] = useMethod(decryptUtilityAccountPassword, _id as string, [_id]);
  return (
    <UtilityAccountPasswordPageStyled className="page">
      {password}
    </UtilityAccountPasswordPageStyled>
  );
};
